import axios from 'axios';
import getApiUrl from '../config/api';

// Production Earnings Actions
export const getProductionEarnings = (params = {}) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/production-earnings`, { params });
        dispatch({ type: 'SET_PRODUCTION_EARNINGS', payload: response.data.data.data || response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch production earnings' });
        throw error;
    }
};

export const createProductionEarning = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/production-earnings`, data);
        dispatch({ type: 'ADD_PRODUCTION_EARNING', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to create production earning' });
        throw error;
    }
};

export const getProductionEarningsSummary = (params) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/production-earnings/summary`, { params });
        dispatch({ type: 'SET_PRODUCTION_EARNINGS_SUMMARY', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch summary' });
        throw error;
    }
};

// Daily Distributions Actions
export const getDailyDistributions = (params = {}) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/daily-distributions`, { params });
        // Handle both paginated and non-paginated responses
        const payload = response.data.data?.data || response.data.data || response.data;
        dispatch({ type: 'SET_DAILY_DISTRIBUTIONS', payload: payload });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch daily distributions' });
        throw error;
    }
};

export const createDailyDistribution = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distributions`, data);
        dispatch({ type: 'ADD_DAILY_DISTRIBUTION', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to create daily distribution' });
        throw error;
    }
};

export const createDailyDistributionFromEarnings = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distributions/create-from-earnings`, data);
        dispatch({ type: 'ADD_DAILY_DISTRIBUTION', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to create distribution from earnings' });
        throw error;
    }
};

export const markDistributionAsDistributed = (distributionId) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distributions/${distributionId}/mark-distributed`);
        dispatch({ type: 'UPDATE_DAILY_DISTRIBUTION', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to mark distribution as distributed' });
        throw error;
    }
};

export const getDailyDistributionsSummary = (params) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/daily-distributions/summary`, { params });
        dispatch({ type: 'SET_DAILY_DISTRIBUTIONS_SUMMARY', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch distributions summary' });
        throw error;
    }
};

export const getSalaryStatement = (params) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/daily-distributions/salary-statement`, { params });
        dispatch({ type: 'SET_SALARY_STATEMENT', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch salary statement' });
        throw error;
    }
};

// Daily Distribution Items Actions
export const getDailyDistributionItems = (distributionId) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/daily-distribution-items`, { 
            params: { daily_distribution_id: distributionId } 
        });
        dispatch({ type: 'SET_DAILY_DISTRIBUTION_ITEMS', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch distribution items' });
        throw error;
    }
};

export const createDailyDistributionItem = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distribution-items`, data);
        dispatch({ type: 'ADD_DAILY_DISTRIBUTION_ITEM', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to create distribution item' });
        throw error;
    }
};

export const updateDailyDistributionItem = (id, data) => async (dispatch) => {
    try {
        const response = await axios.put(`${getApiUrl()}/daily-distribution-items/${id}`, data);
        dispatch({ type: 'UPDATE_DAILY_DISTRIBUTION_ITEM', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to update distribution item' });
        throw error;
    }
};

export const bulkCreateDailyDistributionItems = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distribution-items/bulk`, data);
        dispatch({ type: 'ADD_DAILY_DISTRIBUTION_ITEMS', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to create distribution items' });
        throw error;
    }
};

export const getAvailableEmployees = (distributionId) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/daily-distribution-items/available-employees`, {
            params: { daily_distribution_id: distributionId }
        });
        dispatch({ type: 'SET_AVAILABLE_EMPLOYEES', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch available employees' });
        throw error;
    }
};

// Salary Statement Actions
export const generateMonthlySalaryStatement = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/salary-statements/generate-monthly`, data);
        dispatch({ type: 'SET_SALARY_STATEMENT', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to generate salary statement' });
        throw error;
    }
};

export const getSalaryStatementSummary = (params) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/salary-statements/summary`, { params });
        dispatch({ type: 'SET_SALARY_STATEMENT_SUMMARY', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch salary statement summary' });
        throw error;
    }
};

export const deleteAndRecreateDistribution = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distributions/delete-and-recreate`, data);
        dispatch({ type: 'SET_SUCCESS_MESSAGE', payload: response.data.message });
        // Refresh the list with the date from the data
        const today = new Date();
        const todayString = today.toISOString().split('T')[0];
        
        dispatch(getDailyDistributions({ 
            firm_id: data.firm_id,
            from_date: data.date || todayString,
            to_date: data.date || todayString
        }));
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to delete and recreate distribution' });
        throw error;
    }
};

export const recalculateDistribution = (data) => async (dispatch) => {
    try {
        const response = await axios.post(`${getApiUrl()}/daily-distributions/recalculate`, data);
        dispatch({ type: 'SET_SUCCESS_MESSAGE', payload: response.data.message });
        // Refresh the list with the date from the data
        const today = new Date();
        const todayString = today.toISOString().split('T')[0];
        
        dispatch(getDailyDistributions({ 
            firm_id: data.firm_id,
            from_date: data.date || todayString,
            to_date: data.date || todayString
        }));
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to recalculate distribution' });
        throw error;
    }
};

export const getEmployeeEarnings = (params) => async (dispatch) => {
    try {
        const response = await axios.get(`${getApiUrl()}/salary-statements/employee-earnings`, { params });
        dispatch({ type: 'SET_EMPLOYEE_EARNINGS', payload: response.data.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch employee earnings' });
        throw error;
    }
};

// Track last fetch to prevent duplicate requests
let lastFetchKey = null;
let isFetching = false;

export const getSalaryStatementForDateRange = (page = 1, params = {}) => async (dispatch) => {
    // Prevent duplicate fetches
    const fetchKey = `${params?.firm_id || ''}_${params?.from_date || ''}_${params?.to_date || ''}_${page}`;
    if (isFetching && lastFetchKey === fetchKey) {
        return; // Already fetching the same data
    }
    
    isFetching = true;
    lastFetchKey = fetchKey;
    dispatch({ type: 'SET_SALARY_STATEMENT_LOADING', payload: true });
    try {
        // Handle case where page might be an object (shouldn't happen, but handle it)
        let pageNumber = 1;
        let actualParams = params;
        
        if (typeof page === 'object' && page !== null && !Array.isArray(page)) {
            // If page is an object, it means params were passed as first argument
            actualParams = page;
            // Get page from URL or use default
            const urlParams = new URLSearchParams(window.location.search);
            pageNumber = parseInt(urlParams.get('page')) || 1;
        } else if (typeof page === 'number') {
            pageNumber = page;
        } else if (typeof page === 'string') {
            pageNumber = parseInt(page) || 1;
        }
        
        // Extract params - ensure we have all required fields
        const queryParams = {
            firm_id: actualParams?.firm_id ? String(actualParams.firm_id) : undefined,
            from_date: actualParams?.from_date ? String(actualParams.from_date) : undefined,
            to_date: actualParams?.to_date ? String(actualParams.to_date) : undefined,
            page: pageNumber,
            per_page: actualParams?.per_page ? parseInt(actualParams.per_page) : 10
        };
        
        // Always try to get from URL as fallback - URL is source of truth
        const urlParams = new URLSearchParams(window.location.search);
        queryParams.firm_id = queryParams.firm_id || urlParams.get('firm_id');
        queryParams.from_date = queryParams.from_date || urlParams.get('from_date');
        queryParams.to_date = queryParams.to_date || urlParams.get('to_date');
        queryParams.per_page = queryParams.per_page || parseInt(urlParams.get('per_page')) || 10;
        
        // Remove any undefined, null, or empty string values
        Object.keys(queryParams).forEach(key => {
            if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
                delete queryParams[key];
            }
        });
        
        // Validate required params before making request
        if (!queryParams.firm_id || !queryParams.from_date || !queryParams.to_date) {
            console.error('Missing required params for salary statement:', queryParams);
            console.error('URL params:', {
                firm_id: urlParams.get('firm_id'),
                from_date: urlParams.get('from_date'),
                to_date: urlParams.get('to_date')
            });
            dispatch({ type: 'SET_SALARY_STATEMENT_LOADING', payload: false });
            isFetching = false;
            dispatch({ 
                type: 'SET_ERROR', 
                payload: 'Missing required parameters: firm_id, from_date, or to_date' 
            });
            return;
        }
        
        const response = await axios.get(`${getApiUrl()}/salary-statements/date-range`, { params: queryParams });
        
        dispatch({ 
            type: 'SET_SALARY_STATEMENT', 
            payload: {
                data: response.data.data,
                currentPage: response.data.current_page,
                numberOfPages: response.data.last_page,
                total: response.data.total,
                perPage: response.data.per_page
            }
        });
        dispatch({ type: 'SET_SALARY_STATEMENT_LOADING', payload: false });
        isFetching = false;
        return response.data;
    } catch (error) {
        dispatch({ type: 'SET_SALARY_STATEMENT_LOADING', payload: false });
        isFetching = false;
        dispatch({ type: 'SET_ERROR', payload: error.response?.data?.message || 'Failed to fetch salary statement' });
        throw error;
    }
};

// Page Table Actions
export const setCurrentPage = (page) => (dispatch) => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: page });
};

export const setItemsPerPage = (itemsPerPage) => (dispatch) => {
    dispatch({ type: 'SET_ITEMS_PER_PAGE', payload: itemsPerPage });
};

export const setManualCashAmount = (employeeId, amount, dateKey = null) => (dispatch) => {
    const key = dateKey ? `${employeeId}_${dateKey}` : employeeId;
    dispatch({ type: 'SET_MANUAL_CASH_AMOUNT', payload: { key, amount } });
};

export const setAttendanceStatus = (employeeId, status, dateKey = null) => (dispatch) => {
    const key = dateKey ? `${employeeId}_${dateKey}` : employeeId;
    dispatch({ type: 'SET_ATTENDANCE_STATUS', payload: { key, status } });
};

export const setEditingState = (employeeId, isEditing, dateKey = null) => (dispatch) => {
    const key = dateKey ? `${employeeId}_${dateKey}` : employeeId;
    dispatch({ type: 'SET_EDITING_STATE', payload: { key, isEditing } });
};

export const setEditingAmount = (amount) => (dispatch) => {
    dispatch({ type: 'SET_EDITING_AMOUNT', payload: amount });
};

export const setSavingPageData = (isSaving) => (dispatch) => {
    dispatch({ type: 'SET_SAVING_PAGE_DATA', payload: isSaving });
};

export const setSaveError = (error) => (dispatch) => {
    dispatch({ type: 'SET_SAVE_ERROR', payload: error });
};

export const clearManualCashAmounts = () => (dispatch) => {
    dispatch({ type: 'CLEAR_MANUAL_CASH_AMOUNTS' });
};

export const clearAttendanceStatuses = () => (dispatch) => {
    dispatch({ type: 'CLEAR_ATTENDANCE_STATUSES' });
};

export const clearEditingStates = () => (dispatch) => {
    dispatch({ type: 'CLEAR_EDITING_STATES' });
};

// Save distribution data action
export const saveDistributionData = (data) => async (dispatch) => {
    try {
        dispatch(setSavingPageData(true));
        dispatch(setSaveError(null));
        
        const response = await axios.post(`${getApiUrl()}/daily-distributions/salary/save-distribution-data`, data);
        
        dispatch(setSavingPageData(false));
        return response.data;
    } catch (error) {
        dispatch(setSavingPageData(false));
        const errorMessage = error.response?.data?.message || 'Failed to save distribution data';
        dispatch(setSaveError(errorMessage));
        throw error;
    }
};

// Utility Actions
export const clearSalarySystemData = () => (dispatch) => {
    dispatch({ type: 'CLEAR_SALARY_SYSTEM_DATA' });
};

export const clearError = () => (dispatch) => {
    dispatch({ type: 'CLEAR_ERROR' });
};
